import { render, staticRenderFns } from "./recirculo.vue?vue&type=template&id=bf3b7c74&scoped=true&"
import script from "./recirculo.vue?vue&type=script&lang=js&"
export * from "./recirculo.vue?vue&type=script&lang=js&"
import style0 from "./recirculo.vue?vue&type=style&index=0&id=bf3b7c74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3b7c74",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CaseIntro: require('/app/components/case/intro.vue').default,CaseContent: require('/app/components/case/content.vue').default,CaseList: require('/app/components/case/list.vue').default,CaseCta: require('/app/components/case/cta.vue').default,CaseRelated: require('/app/components/case/related.vue').default})
